// extracted by mini-css-extract-plugin
module.exports = {"divider":"OrdersList_divider__22477"};